import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { isProd, mode } from "./lib/mode.js";
export const Environment = () => !isProd ? (_jsx(Typography, { component: "div", sx: {
        position: "fixed",
        bottom: -36,
        right: -72,
        width: 192,
        pb: 12,
        textAlign: "center",
        bgcolor: "rgba(48, 129, 80, 0.7)",
        color: "#FFF",
        transform: "rotate(-45deg)",
        textTransform: "uppercase",
        pointerEvents: "none",
        fontWeight: "bold",
    }, children: mode })) : null;
//# sourceMappingURL=Environment.js.map